
import { Modal } from "react-bootstrap";
import React from "react";

const XpressBookDaasPopup = ({showConfirmBookDaasPopup, handleConfirmBookDaas, setShowConfirmBookDaasPopup}) =>{
    
    return (
        <div>{showConfirmBookDaasPopup ?
            <Modal show={showConfirmBookDaasPopup} backdrop="static">
              <Modal.Header>
                <Modal.Title>Are you sure you want to book daas?</Modal.Title>
              </Modal.Header>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleConfirmBookDaas();
                  }}
                >
                  Confirm
                </button>

                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setShowConfirmBookDaasPopup(false)}>
                  Cancel
                </button>
              </Modal.Footer>

            </Modal>
            :
            null
          }</div>
    )
}

export default XpressBookDaasPopup;